import { getStockImageRepository } from './stock-image-repository';
import { getBasicAssetsRepository } from './basic-assets-repository';

export const getLibraryAndStockImageRepository = ({
  aid,
  cid,
  oDataConfig,
  folderODataService,
  i18n,
  ianaTimeZone,
  timezoneUTCOffset,
  assetType,
  logger,
}) => {
  const sourceNames = ['library', 'stockImage'];
  //
  const libraryRepository = getBasicAssetsRepository({
    folderODataService,
    i18n,
    ianaTimeZone,
    timezoneUTCOffset,
    assetType,
    logger,
  });

  const stockImageRepository = getStockImageRepository({
    aid, cid, oDataConfig,
  });

  const loadAssets = ({
    windowIndex, windowSize, sourceName, ...rest
  }) => {
    let $ret = null;
    if (sourceName === 'stockImage') {
      $ret = stockImageRepository.loadAssets({ windowIndex, windowSize, ...rest });
    } else {
      $ret = libraryRepository.loadAssets({
        windowIndex,
        windowSize,
        isSemanticSearch: true,
        ...rest,
      });
    }
    return $ret;
  };

  return {
    loadAssets,
    renameAsset: libraryRepository.renameAsset,
    sourceNames,
  };
};
